import { Separator } from "@/elements"
import React from "react"

interface Props {}

export const ApplyToJobContentSkeleton: React.FC<Props> = () => {
  return (
    <div className="relative h-full w-full">
      <div className="flex flex-row items-start md:mt-16">
        <div className="mr-6 size-[48px] animate-pulse rounded-md bg-bg-2 md:size-[64px]" />
        <div className="h-[28px] w-full animate-pulse bg-bg-2" />
      </div>
      <div className="py-9">
        <Separator />
      </div>
      <div className="mt-6 h-[26px] w-[150px] animate-pulse bg-bg-2" />
      <div className="mt-2 flex w-full flex-row items-center justify-between">
        <div className="h-[20px] w-[220px] animate-pulse bg-bg-2" />
        <div className="h-[20px] w-[160px] animate-pulse bg-bg-2" />
      </div>
      <div className="mt-4 h-[300px] w-full animate-pulse rounded-lg bg-bg-2" />

      <div className="mt-6 h-[20px] w-[72px] animate-pulse bg-bg-2" />
      <div className="mt-2 h-[87px] w-full animate-pulse rounded-lg bg-bg-2" />
    </div>
  )
}
